import {combineReducers} from 'redux';
import UserReducer from './modules/user/reducer';

// 模块化管理状态
const reducer = combineReducers({
    user: UserReducer
});

export default reducer;
